<template>
  <a-card :bordered="false">
    
    <!-- 上部订单查询 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="供应商名称">
              <a-select showSearch v-model="queryParam.supplierId" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in supplierSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="物料名称">
              <a-select showSearch v-model="queryParam.materielId"  style="max-width: 320px"
                :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24">
            <a-form-item label="合同号">
              <a-input v-model.trim="queryParam.contractNo" placeholder="" />
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24" style="float:right"> 
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="refreshData">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="订单状态" >
              <a-select showSearch v-model="queryParam.status"  style="max-width: 320px"
                :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in orderStatusList" :key="index" :value="item.value">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="14" :sm="24">
            <a-form-item label="查询日期">
              <a-date-picker
                format="YYYY-MM-DD"
                v-model="queryParam.startDate"
                placeholder=""
                :disabledDate="disabledDate"
              />
              至
              <a-date-picker
                format="YYYY-MM-DD"
                v-model="queryParam.endDate"
                placeholder=""
                :disabledDate="disabledDate"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" v-if="roleId === config.RoleType.PURCH || roleId === config.RoleType.PLAN">
      <a-button type="primary" icon="plus" @click="addOrder()">创建订单</a-button>
      <a-button v-if='(roleId === config.RoleType.PURCH || roleId === config.RoleType.PLAN) && selectRow && selectRow.status !== config.OrderStatus.CANCELED' type="primary" icon="plus" @click="addDetails()" style="margin-left:20px;">添加子订单</a-button>
    </div>

    <!-- 订单列表 -->
    <s-table ref="table" :pageSize="pageSize" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"

      :columns="columns" :data="loadData" :scroll="{ x: 1590}" 
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,hideDefaultSelections:hideDefaultSelections,type:'radio' }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}">

      <span slot="action" slot-scope="text, record" v-if="record.status !== config.OrderStatus.CANCELED">
        <a @click="editorOrder(record)" v-if=' (roleId === config.RoleType.PURCH || roleId === config.RoleType.PLAN)  && !record.hasValidChildren'>编辑</a>
       
 <!--        <a-divider type="vertical" v-if='roleId === config.RoleType.PURCH || roleId === config.RoleType.PLAN'/>
        <a @click="cancelOrder(record)" v-if='roleId === config.RoleType.PURCH || roleId === config.RoleType.PLAN'>作废</a> -->
      </span>

      <span slot="status" slot-scope="text, record, index">
        {{record.status !== config.OrderStatus.CANCELED?"否":"是"}}
        <span class="blacktr" v-if='record.status === config.OrderStatus.CANCELED'></span>
        <span class="removeblacktr" v-if='record.status !== config.OrderStatus.CANCELED'></span>
      </span>
        
    </s-table>

    <!-- 子订单列表 -->
    <a-table ref="table2" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
        :columns="detailsColumns" :dataSource="detailsList" :scroll="{ x: 2200}" 
        :pagination="false">
  
        <span slot="detailsStatus" slot-scope="text, record, index">
          {{ getTextByOrderStatus(record.status)}}
          <span class="sub_blacktr" v-if='record.status === config.OrderStatus.CANCELED'></span>
          <span class="sub_removeblacktr" v-if='record.status !== config.OrderStatus.CANCELED'></span>
        </span> 

        <template slot="orderOperation" slot-scope="text, record, index" >
          <span v-if='record.status !== config.OrderStatus.CANCELED && record.status !== config.OrderStatus.AUDITED && (roleId === config.RoleType.PURCH || roleId === config.RoleType.PLAN)'>
            <a @click="editDetails(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="cancelDetails(record)">作废</a>
          </span>
        </template>
    </a-table>

    <!-- 订单添加和修改 -->
    <a-modal
      title="操作"
      style="top: 10px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="visible.order"
      :maskClosable="config.globlaMaskClosable"
      @ok="saveOrderCg"
      destroyOnClose
    >
      <a-form :form="orderForm">
        <!--   <a-form-item label="订单号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input
              :disabled="disabled"
              placeholder=""
              v-decorator="['orderNo', { initialValue: orderMdl.orderNo, rules: [{ required: true, message: '请输入订单号'}]}]"
            />
          </a-form-item> -->

        <a-form-item label="供应商名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            :disabled="disabledSupId"
            showSearch
            :filterOption="filterOption"
            placeholder="供应商名称"
            v-decorator="['supplierId',
            { initialValue: orderMdl.supplierId, rules: [{ required: true, message: '请选择供应商名称'}]}]"
          >
            <a-select-option
              v-for="(item, index) in supplierSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="合同编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder=""
            v-decorator="['contractNo', { initialValue: orderMdl.contractNo, rules: [{ required: true, message: '请输入合同编号'}]}]"
          />
        </a-form-item>

        <a-form-item label="合同金额" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number suffix="元"  :min="0" :max="10000000000" :precision="precision" style="width: 296px;"   
            v-decorator="['contractAmount', { initialValue: orderMdl.contractAmount, rules: [{ required: false, message: '请输入合同金额'}]}]" />
        </a-form-item>

        <a-form-item label="付款方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="付款方式"
            v-decorator="['paymentType',
            { initialValue: orderMdl.paymentType, rules: [{ required: false, message: '请选择付款方式'}]}]"
          >
            <a-select-option
              v-for="(item, index) in paymentTypeList"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

    <!--     <a-form-item label="有效日期" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
              <a-date-picker 
                :defaultValue="defaultDate"  
                :disabledDate="disabledDate"
                style="max-width: 130px"
                v-decorator="['beginTime', { initialValue: orderMdl.beginTime, rules: [{ required: false, message: '请选择生效日期'}]}]"
                placeholder="生效日期" />
                至
                <a-date-picker 
                :defaultValue="defaultDate"  
                :disabledDate="disabledDate"
                style="max-width: 130px"
                v-decorator="['endTime', { initialValue: orderMdl.endTime, rules: [{ required: false, message: '请选择失效日期'}]}]"
                placeholder="失效日期" />
          </a-form-item> -->
      </a-form>
     
    </a-modal>

    <!-- 子订单添加和修改 -->
    <a-modal title="操作" :maskClosable="config.globlaMaskClosable" :footer="footerData" style="top: 10px;" :width="640" :confirmLoading="showLoading" v-model="visible.details" @ok="saveDetails" 
      destroyOnClose>

      <a-form :form="detailsForm">
   
        <a-form-item label="订单号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input :disabled="disabled" placeholder=""
            v-decorator="['orderNo', { initialValue: detailsMdl.orderNo, rules: [{ required: true, message: '请输入订单号'}]}]" />
        </a-form-item>

        <a-form-item label="物料名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select showSearch  :filterOption="filterOption" placeholder="请选择"
          v-decorator="['materielId', { initialValue: detailsMdl.materielId, rules: [{ required: true, message: '请选择物料'}]}]" >
            <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{item.name}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="订单量" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input-number @change="(value) => changeOrderNumber(value)"  :min="0" :precision="precision" style="width: 296px;"   
            v-decorator="['orderNum', { initialValue: detailsMdl.orderNum, rules: [{ required: true, message: '请输入订单量'}]}]" />
        </a-form-item>

        <a-form-item label="是否承运" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-radio-group @change="onRadioChangeIsTransport" v-decorator="['isTransport', { initialValue: detailsMdl.isTransport, rules: [{ required: true, message: '请选择送货方式'}]}]">
              <a-radio value="1">是（自提采购）</a-radio>
              <a-radio value="0">否（送到采购）</a-radio>
            </a-radio-group>
        </a-form-item>

        <a-form-item label="运输方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="运输方式"
            v-decorator="['transportType',
            { initialValue: detailsMdl.transportType, rules: [{ required: true, message: '请选择运输方式'}]}]"
          >
            <a-select-option
              v-for="(item, index) in config.transportTypeList"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="运输地址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['transportAddress', { initialValue: detailsMdl.transportAddress, rules: [{ required: addressRequired, message: '请输入运输地址'}]}]" />
        </a-form-item>

        <a-form-item  v-if="corpProviderSelect.length > 0" label="供货商" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="请选择"
            v-decorator="['providerId',
            { initialValue: detailsMdl.providerId, rules: [{ required: true, message: '请选择供货商'}]}]"
          >
            <a-select-option
              v-for="(item, index) in corpProviderSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="联系方式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['contact', { initialValue: detailsMdl.contact, rules: [{ required: false, message: '请输入联系方式'}]}]" />
        </a-form-item>

        <a-form-item label="联系人" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['contactor', { initialValue: detailsMdl.contactor, rules: [{ required: false, message: '请输入联系人'}]}]" />
        </a-form-item>

        <a-form-item label="交货日期" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-date-picker
                style="width: 296px"
                format="YYYY-MM-DD"
                placeholder=""
                :disabledDate="disabledDateAfterToday"
                v-decorator="['deliveryDate',
                { initialValue: detailsMdl.deliveryDate, rules: [{ required: false, message: '请选择交货日期'}]}]"
              />
        </a-form-item>

        <a-form-item label="备注" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input  placeholder=""
          v-decorator="['memo', { initialValue: detailsMdl.memo, rules: [{ required: false, message: '请输入联系方式'}]}]" />
        </a-form-item>
   
        <a-form-item label="" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-checkbox v-model="continuity" style="float: right; ">连续提交</a-checkbox>
        </a-form-item>
       
      </a-form>

    </a-modal>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import { findListByBusinessTypeId, getCorpSupplierList, findBySupplierId} from '@/api/basic'
  import { cgOrderPage, genCgOrderNo,saveOrderCg, cancelOrderCg,auditOrderCg, saveCgDetails, cancelCgDetails } from '@/api/order'
  import moment from 'moment'
  import { formatDate } from '../../utils/date.js'
  import Bus from '@/layouts/bus'
  import queryMixin from '@/mixins/queryMixin'

  export default {
    name: 'OrderList',
    mixins: [queryMixin],
    components: {
      STable
    },
    data() {
      return {
        // pageSizeOptionsList: ['5','10','20'],
        pageSizeOptionsList: ['5'],
        pageSize:5,
        materielSelect: null,
        supplierSelect: [],
        corpProviderSelect: [],
        description:
          '采购订单管理',
        visible: {
          order:false,
          details:false
        },
        orderStatusList: (this.config.orderStatusList.slice(0,8)).filter(item => item.name.indexOf('销售') === -1 ),
        paymentTypeList: this.config.paymentTypeList.slice(0,2),
        orderForm: this.$form.createForm(this),
        detailsForm: this.$form.createForm(this),

        orderMdl:{},
        detailsMdl:{},

        disabled: true,
        disabledSupId:false,

        defaultTransport:'0',
        defaultDate: moment(new Date(), 'YYYY-MM-DD'),
        defaultNum: 0.00,
        defaultTransportType: this.config.TransportType.vehicle,

        precision:2,
        roleId: null,

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {supplierId:null,startDate:moment().startOf('month'), endDate:moment(new Date(), 'YYYY-MM-DD')},

        loading: false,
        showLoading: false,

        selectMaterielId:null,
        selectMaterielName:null,

        addressRequired: false,
        hideDefaultSelections: true,
        detailsList: [],

        continuity:true,    // 是否连续预约
        footerData:[
        //<a-checkbox checked="checked" onChange={this.changeContinuity} style="float: right; line-height: 2.499;margin-left:10px;">连续操作</a-checkbox>,
        <button type="button" class="ant-btn ant-btn-default" onClick={this.doCancelDetails}><span>取 消</span></button>,
        //<button type="button" class="ant-btn ant-btn-primary" onClick={this.saveDetails}><span>保存</span></button>,
        <button type="button" class="ant-btn ant-btn-primary" onClick={this.submitDetails}><span>提交</span></button>],

        // 表头
        columns:[],
        allColumns: [
          {
            title: '合同编号',
            dataIndex: 'contractNo',
            width: '180px'
          },
          {
            title: '合同金额',
            dataIndex: 'contractAmount',
            width: '100px'
          },
          {
            title: '供应商名称',
            dataIndex: 'supplierName',
            /*  width: '140px' */
          },
          {
            title: '订单号',
            dataIndex: 'orderNo',
            width: '170px',
            //fixed: 'left',
          },
          {
            title: '付款方式',
            dataIndex: 'paymentType',
            width: '80px',
            customRender: text => {
              if (text) {
                for (var i=0; i<this.config.paymentTypeList.length;i++){
                  let payment = this.config.paymentTypeList[i]
                  if (text === payment.value){
                      return payment.name
                  }
                } 
              }
            }
          },
          {
            title: '创建人',
            dataIndex: 'createId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '是否作废',
            //dataIndex: 'isCancel',
            width: '80px',
            scopedSlots: { customRender: 'status' },
           /*  customRender: (text, record) => {
              if (text === '0') {
                return '否'
              }
              return '是'
            } */
          },
          {
            title: '作废人',
            dataIndex: 'cancelId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '作废时间',
            dataIndex: 'cancelTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            fixed: 'right',
            scopedSlots: { customRender: 'action' }
          }
        ],

        detailsColumns: [
          {
            title: '订单行号',
            dataIndex: 'code',
            width: '80px',
            //fixed: 'left',
          },
          {
            title: '物料名称',
            dataIndex: 'materielName',
            /*    width: '80px',  */
          },
          {

            title: '订单量(吨)',
            dataIndex: 'orderNum',
            width: '90px',
          },
          {

            title: '入库量(吨)',
            dataIndex: 'scaleNum',
            width: '90px',
          },
          {

            title: '剩余量(吨)',
            dataIndex: 'remainNum',
            width: '90px',
          },
          {
            title: '订单状态',
            width: '80px',
            scopedSlots: { customRender: 'detailsStatus' },
          }, 
          {
            title: '是否承运',
            dataIndex: 'isTransport',
            width: '80px',
            customRender: (text, record) => {
              if (text === '1') {
                return '是'
              }
              return '否'
            }
          },
          {
            title: '运输方式',
            dataIndex: 'transportType',
            width: '90px',
            customRender: text => {
              if (text) {
                for (var i=0; i<this.config.transportTypeList.length;i++){
                  let transportType = this.config.transportTypeList[i]
                  if (text === transportType.value){
                      return transportType.name
                  }
                } 
              }
            }
          },
          {
            title: '运输地址',
            dataIndex: 'transportAddress',
            width: '180px',
          },
          {
            title: '供货商',
            dataIndex: 'providerId',
            width: '140px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let providerList = this.$store.getters.providerList;
              return providerList[text];
            }
          },
          {
            title: '联系方式',
            dataIndex: 'contact',
            width: '120px',
          },
          {
            title: '联系人',
            dataIndex: 'contactor',
            width: '80px',
          },
          {
            title: '交货日期',
            dataIndex: 'deliveryDate',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '创建人',
            dataIndex: 'createId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '备注',
            dataIndex: 'memo',
            width: '120px',
          },
          {
            title: '作废人',
            dataIndex: 'cancelId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '作废时间',
            dataIndex: 'cancelTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '操作',
            key: 'orderOperation',
            fixed: 'right',
            scopedSlots: { customRender: 'orderOperation' },
            width: '120px',
          }
        ],

    
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          if (this.queryParam.startDate > this.queryParam.endDate){
            this.$message.warning('开始日期不能大于结束日期',3)
            return
          }
          let condition = Object.assign(parameter, this.queryParam)
          if (condition.startDate){
            condition.startDate = formatDate(new Date(condition.startDate), 'yyyy-MM-dd')
          }
          if (condition.endDate){
            condition.endDate = formatDate(new Date(condition.endDate), 'yyyy-MM-dd')
          }
          return cgOrderPage(condition).then(res => {
             setTimeout(() => {
                $('.blacktr').parents('tr').css("background-color", "#cf3659")
                $('.removeblacktr').parents('tr').css("background-color","#fff")
              }, 1000); 
            return res.data
          })
        },
        loadSelect() {
          new Promise(resolve => {
            const data = findListByBusinessTypeId({"businessTypeId":102}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.materielSelect = res
          }),
          new Promise(resolve => {
              const data = getCorpSupplierList({}).then(res => {
                return res.data
              })
              resolve(data)
            }).then(res => {
              this.supplierSelect = res
            /*   if (this.businessSelect && this.businessSelect.length > 0){
                this.queryParam.businessId =  this.businessSelect[0].id
              } */
          })
        },

        selectedRowKeys: [],
        selectedRows: [],
        selectRow:null,
      }
    },
    created() {
      this.loadSelect()
      // 初始化查询条件
      this.queryParam = this.queryParam || null
      this.roleId = this.$store.getters.roles
      
      // 调运部不允许查看合同金额
      if (this.config.RoleType.DISPATCH === this.roleId){
        this.setColumns()
      }else{
        this.columns = this.allColumns
      }
    },

    methods: {
      moment,

      disabledDate(current) {
        return current && current > moment().endOf('day')
      },

      disabledDateAfterToday(current) {
        return current && current < moment().subtract(1, "days")
      },

      loadCorpProviderBySupplierId(supplierId) {
        // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = findBySupplierId({'supplierId':supplierId}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          if (res.length === 0){
            this.detailsMdl.providerId = null
          }else{
            this.corpProviderSelect = res
            this.corpProviderSelect.unshift({'id':-1, 'name':'无'})
          }
        })
      },
      setColumns(){
        let newColumns = []
        this.allColumns.forEach(obj=>{
          if (obj.dataIndex !== 'contractAmount'){
            newColumns.push(obj)
          }
        })
        this.columns = newColumns 
      },
      refreshData(){
        this.$refs.table.refresh()
        this.selectedRowKeys = []
        this.selectedRows = []
        this.selectRow = null
        this.detailsList = []
      },

      onRadioChangeIsTransport(e){
        let isTransport = e.target.value 
        this.addressRequired = isTransport === "1" ? true : false
      },

      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectRow = selectedRows[0]
        this.detailsList = this.selectRow.orderDetailsCgList
        if (this.detailsList.length > 0){
          setTimeout(() => {
            $('.sub_blacktr').parent().parent().parent('tr').css("background-color", "#cf3659")
            $('.sub_removeblacktr').parent().parent().parent('tr').css("background-color","#fff")
          }, 100); 
        }
      },

      getTextByOrderStatus(status){
        for (let i=0; i< this.config.orderStatusList.length; i++){
          let orderStatus = this.config.orderStatusList[i]
          if (orderStatus.value === status ){
            return orderStatus.name.replace("财务",'').replace("销售",'')
          }
        }
      },
      addOrder() {
        this.orderMdl = {isTransport:this.defaultTransport}
        this.orderForm = this.$form.createForm(this)
        this.visible.order = true
        this.disabledSupId = false
      },

      editorOrder(record) {
        this.orderMdl = Object.assign({}, record)
        this.orderForm = this.$form.createForm(this)
        this.visible.order = true
        this.disabledSupId = true
      },

      saveOrderCg() {
        this.orderForm.validateFields((err, values) => {
          if (!err) {
            Object.assign(this.orderMdl, values)
            this.showLoading = true
            saveOrderCg(Object.assign({}, this.orderMdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible.order = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
              })
          }
        })
      },

      cancelOrder(record) {
        var that = this
        this.$confirm({
          title: '提示',
          content: '会同时作废所有子订单，确定要作废吗?',
          onOk() {
            that.confirmLoading = true
            return cancelOrderCg({id:record.id})
              .then(res => {
                if (res.code === '0') {
                  that.refreshData()
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        })
      },

      changeOrderNumber(value) {
        value = parseFloat(value);
        if (!value || isNaN(value)){
          // value = 0;
          // $('#ton-val').text('')
          return;
        }
        let price = this.detailsForm.getFieldValue('price');
        if (price &&  Number(price) > 0){
          let amount = Number(value) * Number(price)
          this.$set(this.detailsMdl, 'amount', amount) 
        }
        //let tonValue = this.keepTwoDecimal(value/1000)
        //$('#ton-val').text(tonValue)
      },

      keepTwoDecimal(num) {
        var result = parseFloat(num);
        if (isNaN(result)) {
          return '';
        }
        result = Math.round(num * 100000) / 100000;
        return result;
      },
      changeOrderPrice(value) {
        value = parseFloat(value);
        if (!value || isNaN(value)){
          // value = 0;
          return;
        }
        let orderNum = this.detailsForm.getFieldValue('orderNum');
        if (orderNum &&  Number(orderNum) > 0){
          let amount = Number(value) * Number(orderNum)
          this.$set(this.detailsMdl, 'amount', amount) 
        }
      },


      addDetails() {
        if (!this.selectRow){
          this.$message.warning('请勾选要操作的主订单!',3)
          return
        }
        let record = this.selectRow
        this.detailsMdl = {scaleNum:this.defaultNum, remainNum:this.defaultNum, orderNo:record.orderNo,isTransport: this.defaultTransport, transportType: this.defaultTransportType}
        this.detailsForm = this.$form.createForm(this)
        this.visible.details = true

        let detailsList = record.orderDetailsCgList
        let length = detailsList.length
        this.detailsMdl.code = length > 0 ? "00"+(parseInt(detailsList[length - 1].code) + 1).toString() : "001"

        this.addressRequired = this.defaultTransport === "1" ? true : false

        this.loadCorpProviderBySupplierId(record.supplierId)
        setTimeout(() => {
           let $orderNum =  $('#orderNum')
           // <span id="ton-val"></span>吨</span>
           $orderNum.find('.ant-input-number-input-wrap').append('<span class="wxf-input-suffix">吨</span><span class="wxf-text-suffix">')
        }, 100); 
      },

      editDetails(record) {
        this.detailsMdl = Object.assign({}, record)
        this.detailsForm = this.$form.createForm(this)
        this.visible.details = true
        this.detailsMdl.orderNo = record.orderNo
        this.addressRequired = this.detailsMdl.isTransport === "1" ? true : false
        if (!this.detailsMdl.providerId){
          this.detailsMdl.providerId = -1
        }
      },

      cancelDetails(record) {
        var that = this
        this.$confirm({
          title: '提示',
          content: '确定要作废吗?',
          onOk() {
            that.confirmLoading = true
            return cancelCgDetails({id:record.id, orderNo:record.orderNo, queryStatus:that.queryParam.status})
              .then(res => {
                if (res.code === '0') {
                  that.detailsList = res.data
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        })
      },

      doCancelDetails(){
          this.visible.details = false
      },

      saveDetails(ele) {
        this.submitDetails(ele,this.config.OrderStatus.SAVED)
      },

      submitDetails(ele, status) {
        status = status || this.config.OrderStatus.AUDITED
        this.detailsForm.validateFields((err, values) => {
          if (!err) {
            this.showLoading = true
            Object.assign(this.detailsMdl, values)
            this.detailsMdl.status = status
            this.detailsMdl.queryStatus = this.queryParam.status
            if (this.detailsMdl.providerId === -1){
              this.detailsMdl.providerId = null
            }
            saveCgDetails(Object.assign({}, this.detailsMdl))
              .then(res => {
                if (res.code === '0') {
                  this.detailsList = res.data
                  this.$message.success('添加成功', 3)
                  if (this.continuity){
                    this.detailsMdl = {scaleNum:this.defaultNum, remainNum:this.defaultNum, orderNo:this.detailsMdl.orderNo,isTransport: this.defaultTransport, transportType: this.defaultTransportType}
                    this.$set(this.detailsMdl, 'orderNum', null) 
                    this.$set(this.detailsMdl, 'transportAddress', null) 
                    this.$set(this.detailsMdl, 'contact', null) 
                    this.$set(this.detailsMdl, 'deliveryDate', null) 
                    this.$set(this.detailsMdl, 'memo', null) 
                    this.addressRequired = this.detailsMdl.isTransport === "1" ? true : false
                    this.detailsForm = this.$form.createForm(this)
                    this.$refs.table.refresh()
                  }else{
                    this.visible.details = false
                    this.continuity = true
                  }
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
            })
          }
        })
      },

      filterOption(input, option) {
        // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      onChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    },
    watch: {}
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }

   /deep/ .wxf-input-suffix {
    right: 28px;
    position: absolute;
    top: 50%;
    z-index: 2;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    line-height: 0;
    color: rgba(0, 0, 0, 0.65);
  }

  /deep/ .wxf-text-suffix {
    right: -85px; 
    position: absolute;
    top: 50%;
    z-index: 2;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    line-height: 0;
    color: rgba(0, 0, 0, 0.65);
  }
</style>